export const LangMyVideos = {
    title: {
        it: 'Lista video',
        en: 'Videos'
    }
};
